
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"aria-hidden":"true","viewBox":"0 0 10 11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.515 5.449a.456.456 0 00-.624-.09l-.707.5a.417.417 0 00-.099.598l3.374 4.409c.144.188.363.177.487-.026l5.992-9.763a.418.418 0 00-.16-.587L9.023.06a.455.455 0 00-.61.147l-4.63 7.544c-.124.203-.343.213-.49.02L1.515 5.45z"}})])
          )
        }
      }
    